/**
 * Config: Navigation
 * -----------------------------------------------------------------------------
 * Define special meta values for navigation.
 *
 */
export const specialLinks = {
  banner: '[banner]',
  bannerTitle: '[banner-title]',
  col: '[col-',
  colBreak: '[col-break]',
  color: '[color]',
  ctaStatus: '[show-cta]',
  heading: '[heading]',
}

export const metaLinks = {
  banner: specialLinks.banner,
  bannerTitle: specialLinks.bannerTitle,
  color: specialLinks.color,
  ctaStatus: specialLinks.ctaStatus,
}
